<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="template-page mt-5" v-else-if="loaded" >
        
        <div class="col-12 col-md-8 offset-md-2" >            
            <div class="row no-gutters" >
                <h2 class="h2"  > Merge leads </h2>
            </div>      
            <div class="row no-gutters mt-3" >            

                <b-form  @submit.prevent="getdata" class="atlass-form col-12" >
                    <div class="row">

                        <div class="col-12 form-group" >
                            <label for="NameInput" > Lead ID: </label>
                            <b-form-input id="NameInput" 
                            type="text"
                            v-model="ID"
                            required

                            placeholder="Lead ID">
                            </b-form-input>
                        </div>
                        
                        <div class="col-12 form-group" >
                            <b-button type="submit" variant="primary" class="btn-sm-w" >Search</b-button>
                        </div>
                        
                        <div class="col-12 form-group" v-if="leadToMerge != null" >
                            Lead to merge: <br>
                            {{ leadToMerge.firstname }} {{ leadToMerge.lastname }} <br>
                            {{ leadToMerge.email }}
                        </div>
                        
                        <div class="col-12 form-group" v-if="leadToMerge != null" >
                            <b-button @click="preventMerge()" variant="success" class="btn-sm-w" >Merge</b-button>
                        </div>

                    </div>
                </b-form>
                
                
            </div>
        </div>

    </div>

</template>

<script>
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'leadToMerge',
    props: {
        data: { 
            type: [String, Object],
        }
        
    },
    data: function(){
        return {
            loaded: false,
            ID:null,
            leadToMerge: null
        }
    },
    ready: function (){
        
    },
    beforeCreate: function (){
        //this.$store.dispatch(PROFILE_REQUEST);
        
    },
    mounted(){
        this.loaded = true
    },
    created: function () {
        
    },
    beforeDestroy() {
    },
    methods: {
        getdata: function(){
            
            if( this.ID != this.data.id ){
                let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )

                const db = firebase.firestore();
                var ref = db.collection('organizations/'+orgID+'/leads').doc(this.ID)

                return ref.get()
                .then((snapshot) => {
                    //console.log(snapshot.data())
                    this.leadToMerge = snapshot.data()
                    this.leadToMerge.id = snapshot.id

                })
            }else{
                
                this.$toast.warn({
                    title: 'Warning',
                    message: "You cannot merge the same lead. Please make sure to select another lead ID"
                })
                
            }
                
            
        },

        preventMerge(){
            
            this.$parent.$parent.mergeLeads( this.leadToMerge.id )
            
            if( this.leadToMerge.email == "" || this.leadToMerge.email == this.data.email ){
                //this.$parent.$parent.mergeLeads( this.leadToMerge.id )
            }else{
                console.log("cannot merge leads. Emails are different")
            }
            
        },
        
        submit: function(){
            

            
        },


    },
    computed: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/leadToMerge.vue